import styled from 'styled-components';

import { ColorPalette } from '../../App/global.styles';

export const ContactPageContainer = styled.div`
	padding: 20px 20px 120px 20px;

	@media screen and (max-width: 800px) {
		padding: 20px 60px;
	}

	@media screen and (max-width: 600px) {
		padding: 20px;
	}
`;

export const ContactsHeader = styled.h1`
	text-align: center;
	font-size: 3.5rem;
	line-height: 1.5rem;

	@media screen and (max-width: 1400px) {
		text-align: center;
	}

	@media screen and (max-width: 1000px) {
		font-size: 2.5rem;
	}
`;

export const ContactsParagraph = styled.div`
	align-self: center;
	color: ${ColorPalette.paragraph};
	font-size: 1.3rem;
	font-weight: 400;
	text-align: center;
	padding-top: 0.8rem;

	@media screen and (max-width: 1400px) {
		text-align: center;
	}

	@media screen and (max-width: 1000px) {
		font-size: 1.1rem;
		padding-top: unset;
	}
`;

export const EmailLinkButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	@media screen and (max-width: 1400px) {
		align-items: center;
		justify-content: center;
	}
`;

export const EmailLinkButton = styled.div`
	margin-top: 1.5rem;
	background-color: ${ColorPalette.button};
	color: ${ColorPalette.buttonText};
	margin-right: 0.6rem;
	margin-bottom: 0.6rem;
	padding: 10px 15px;
	border-radius: 3px;
	font-size: 1rem;
	font-weight: 700;
`;
